import * as React from 'react';
import { FormError, FormLabel, FormLabelHelp, FormRow } from '../../components/form';
import { FormInputPassword } from '../../components/form/form-input/FormInputPassword';
import { ContentRow } from '../content-row/ContentRow';

interface ISetPasswordProps {
	onPasswordChange: (password: string, isValid: boolean) => any;
	isReset?: boolean;
}

interface ISetPasswordState {
	valid: boolean;
	password1: string;
	password2: string;
}

export class SetPassword extends React.Component<ISetPasswordProps, ISetPasswordState> {

	constructor(props: ISetPasswordProps) {
		super(props);
		this.state = { valid: true, password1: '', password2: '' };
	}

	public onChange(key: keyof ISetPasswordState, value: string) {
		const state = this.state || {} as ISetPasswordState;
		let valid = state.valid;
		const { password1, password2 } = state;
		if (key === 'password1') {
			valid = !(value && password2) || value === password2;
		} else if (key === 'password2') {
			valid = !(password1 && value) || password1 === value;
		}
		this.props.onPasswordChange(value, valid);
		this.setState({ ...state, [key]: value, valid });
	}

	public render() {
		const state = this.state || {} as ISetPasswordState;
		const change1 = this.onChange.bind(this, 'password1');
		const change2 = this.onChange.bind(this, 'password2');
		return (
			<React.Fragment>
				<p>For security, your password should contain:</p>
				<ul>
					<li>A mixture of letters and numbers</li>
					<li>At least one uppercase and one lowercase letter</li>
					<li>At least 8 characters</li>
				</ul>
				<ContentRow>
					<a href="https://travelnest.freshdesk.com/support/solutions/articles/101000386361-how-to-create-a-strong-password"
						target="_blank">How do I create a strong password?</a>
				</ContentRow>
				<FormRow>
					{this.props.isReset ?
						<FormLabel htmlFor="password1">Enter new password</FormLabel> :
						<FormLabel htmlFor="password1">Enter password</FormLabel>}
					<FormInputPassword
						onChange={(e) => change1(e.target.value)}
						id="password1"
						name="password1"
						required
						data-matomo-mask
					/>
				</FormRow>
				<FormRow>
					{this.props.isReset ?
						<FormLabel htmlFor="password2">Enter new password again</FormLabel> :
						<FormLabel htmlFor="password2">Enter password again</FormLabel>}
					<FormLabelHelp>Make sure it matches what you have entered above</FormLabelHelp>
					<FormInputPassword
						onChange={(e) => change2(e.target.value)}
						id="password2"
						name="password2"
						required
						data-matomo-mask
					/>
				</FormRow>
				{!state.valid &&
					<FormError>
						<p>The passwords you have entered do not match.<br />Try entering your chosen password again.</p>
					</FormError>
				}
			</React.Fragment>
		);
	}
}
